import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type MyActiveAiChatConversationQueryVariables = Types.Exact<{ [key: string]: never }>

export type MyActiveAiChatConversationQuery = {
  myActiveAiChatConversation?: {
    id?: string | null
    title?: string | null
    status: string
    totalInputTokens: number
    totalOutputTokens: number
    createdAt?: string | null
    updatedAt?: string | null
    agent?: { id: string; name?: string | null } | null
    messages: Array<{
      id?: string | null
      role: string
      content?: string | null
      status: string
      toolCalls: any
      usage: any
      viewContext: any
      createdAt?: string | null
      updatedAt?: string | null
      uploads: Array<{ attachmentFilename?: string | null; attachmentUrl?: string | null }>
    }>
  } | null
}

export const MyActiveAiChatConversationDocument = gql`
  query myActiveAiChatConversation {
    myActiveAiChatConversation {
      id
      title
      status
      agent {
        id
        name
      }
      totalInputTokens
      totalOutputTokens
      createdAt
      updatedAt
      messages {
        id
        role
        content
        status
        toolCalls
        usage
        viewContext
        createdAt
        updatedAt
        uploads {
          attachmentFilename
          attachmentUrl
        }
      }
    }
  }
`

/**
 * __useMyActiveAiChatConversationQuery__
 *
 * To run a query within a React component, call `useMyActiveAiChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyActiveAiChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyActiveAiChatConversationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyActiveAiChatConversationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyActiveAiChatConversationQuery,
    MyActiveAiChatConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyActiveAiChatConversationQuery, MyActiveAiChatConversationQueryVariables>(
    MyActiveAiChatConversationDocument,
    options
  )
}
export function useMyActiveAiChatConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyActiveAiChatConversationQuery,
    MyActiveAiChatConversationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MyActiveAiChatConversationQuery,
    MyActiveAiChatConversationQueryVariables
  >(MyActiveAiChatConversationDocument, options)
}
export function useMyActiveAiChatConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyActiveAiChatConversationQuery,
        MyActiveAiChatConversationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MyActiveAiChatConversationQuery,
    MyActiveAiChatConversationQueryVariables
  >(MyActiveAiChatConversationDocument, options)
}
export type MyActiveAiChatConversationQueryHookResult = ReturnType<
  typeof useMyActiveAiChatConversationQuery
>
export type MyActiveAiChatConversationLazyQueryHookResult = ReturnType<
  typeof useMyActiveAiChatConversationLazyQuery
>
export type MyActiveAiChatConversationSuspenseQueryHookResult = ReturnType<
  typeof useMyActiveAiChatConversationSuspenseQuery
>
export type MyActiveAiChatConversationQueryResult = Apollo.QueryResult<
  MyActiveAiChatConversationQuery,
  MyActiveAiChatConversationQueryVariables
>
